module.exports = __webpack_public_path__ + "img/img_charge_img5.4aec1d76.png";